import { useOptimisticUpdateMutation } from "../../../hooks/useOptimisticUpdateMutation";
import {
  IPaginatedListOfComponentTemplateDto,
  PaginatedListOfComponentTemplateBriefDto,
} from "@growth-machine-llc/stridist-api-client";
import { COMPONENT_TEMPLATES_LIBRARY_QUERY_KEY } from "../ComponentTemplateLibrary";
import { useQueryClient } from "@tanstack/react-query";
import { COMPONENT_TEMPLATES_LIST_QUERY_KEY } from "../../component-template/ComponentTemplateDialog";
import { ComponentStatus } from "../../../constants";
import ComponentsService from "../../../services/ComponentsService";

export const useArchiveLibraryComponentTemplateMutation = () => {
  const queryClient = useQueryClient();

  return useOptimisticUpdateMutation({
    successToastMessage: "Template archived",
    queryKey: [
      COMPONENT_TEMPLATES_LIBRARY_QUERY_KEY,
      { status: ComponentStatus.PUBLISHED },
    ],
    mutationFn: ComponentsService.archiveComponentTemplate,
    optimisticUpdater: {
      updateFn: (oldData: IPaginatedListOfComponentTemplateDto, id) => {
        return {
          ...oldData,
          items: oldData.items.filter((item) => item.id !== id),
        };
      },
    },
    invalidateQueryOptions: {
      enabled: true,
      refetchType: "none",
    },
    exactQueryKey: false,
    options: {
      onSuccess(_, variables) {
        queryClient.invalidateQueries({
          queryKey: [
            COMPONENT_TEMPLATES_LIBRARY_QUERY_KEY,
            {
              status: ComponentStatus.ARCHIVED,
            },
          ],
        });

        queryClient.setQueryData(
          [COMPONENT_TEMPLATES_LIST_QUERY_KEY],
          (oldData: PaginatedListOfComponentTemplateBriefDto) => {
            if (!oldData) return oldData;
            return PaginatedListOfComponentTemplateBriefDto.fromJS({
              ...oldData,
              items: oldData.items.filter((item) => item.id !== variables),
            });
          },
        );
      },
    },
  });
};
